import { isBrowser } from '@jarvis.oddle/core/env'

export const formatPhone = (phoneNumber) => {
  // safety check, just in case the browser cannot access intlTelInputUtils
  let formattedNumber = phoneNumber
  if (isBrowser() && window.intlTelInputUtils) {
    const format = window.intlTelInputUtils.numberFormat.INTERNATIONAL
    formattedNumber = window.intlTelInputUtils.formatNumber(
      phoneNumber,
      null,
      format
    )
  }
  return formattedNumber
}
